module.exports = "#panel-cart.show + #body-overlay {\r\n    display: block;\r\n}"